module.exports = __webpack_public_path__ + "img/file-type-text-alt.81280053.svg";